<template>
  <tr class="voucher-segment-list-item">
    <td>
      {{ item.name }}
    </td>

    <td>
      {{ type }}
    </td>

    <td>
      {{ onceTimePerDay }}
    </td>

    <td>
      {{ createdAt }}
    </td>

    <td>
      <voucher-segment-listItem-actions :item="item"
                                        @deleted="emitReload" />
    </td>
  </tr>
</template>

<script>
import VoucherSegmentListItemActions from "@components/modules/voucher/segment/list/item/actions/VoucherSegmentListItemActions.vue";

export default {
  components: {
    VoucherSegmentListItemActions,
  },

  data() {
    return {};
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    type() {
      return {
        ["VOUCHER_CODE"]: "Voucher",
        ["LOGIN_AND_PASSWORD"]: "Login e senha",
      }[this.item.type];
    },
    onceTimePerDay() {
      return this.item.onceTimePerDay ? "Sim" : "Não";
    },
    createdAt() {
      return this.$date.format(this.item.insertDate);
    },
  },

  methods: {
    emitReload() {
      this.$emit("reload");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
